import { createFileRoute, redirect } from "@tanstack/react-router";
import BusinessCasePage from "@/pages/BusinessCasePage";
import { businessCases } from "@/data/businessCases";
import { SITE_URL } from "@/lib/site-url";

export const Route = createFileRoute("/en/real-cases/$slug")({
  loader: ({ params }) => {
    const found = businessCases.find((c) => c.slug === params.slug);
    if (!found) throw redirect({ to: "/en/real-cases", statusCode: 301 });
    return { title: found.titleEn, description: found.challengeEn.slice(0, 155), slug: found.slug };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [{ title: "Real cases | Retail Lemon" }, { name: "robots", content: "noindex" }] };
    const title = `${loaderData.title} | Retail Lemon`;
    const url = `${SITE_URL}/en/real-cases/${loaderData.slug}`;
    const alternateUrl = `${SITE_URL}/casos-reales/${loaderData.slug}`;
    return {
      meta: [
        { title },
        { name: "description", content: loaderData.description },
        { property: "og:title", content: title },
        { property: "og:description", content: loaderData.description },
        { property: "og:url", content: url },
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: loaderData.description },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "es", href: alternateUrl },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "x-default", href: alternateUrl },
      ],
    };
  },
  component: CaseRoute,
});

function CaseRoute() {
  const { slug } = Route.useParams();
  return <BusinessCasePage slug={slug} routeLang="en" />;
}
